import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import * as $ from 'jquery';
import { TweenMax } from "gsap";
import { Title } from '@angular/platform-browser';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-beneficio-covid19',
  templateUrl: './beneficio-covid19.component.html',
  styleUrls: ['./beneficio-covid19.component.scss']
})
export class BeneficioCovid19Component implements OnInit {
  public isBrowser = isPlatformBrowser(this.platformId);
  public isServer = isPlatformServer(this.platformId);

  constructor(
    private titleService: Title,
    @Inject(PLATFORM_ID) private platformId: any,
    private gtmService: GoogleTagManagerService,
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle('Beneficio clientes vulnerables Covid-19 - Centro de Ayuda');

    if (this.isBrowser) {
      if (environment.production) {
        this.gtmService.addGtmToDom();
      }
      
      setTimeout(() => {
        $(".paso-1")[0].scrollIntoView();
      }, 500);
    }
  }
}
